import gql from "graphql-tag";

export const ParentFragment = gql`
  fragment ParentFragment on Parent {
    uid
    name
    photo
    publicName
    introduction
    created_at
    deleted_at
    timeZone
    socialOptOut
  }
`;

export const ParentLeaderFragment = gql`
  fragment ParentLeaderFragment on Parent {
    uid
    name
    photo
    timeZone
  }
`;

export const ParentAdminFragment = gql`
  fragment ParentAdminFragment on Parent {
    uid
    name
    email
    photo
    timeZone
  }
`;
